/*
  Ported from src/components/HelmetCompatibilityWizard.tsx. Result panels for
  all helmet types are pre-rendered (hidden) and toggled client-side — no
  network round-trip on selection, matching the original's instant local state.
*/
(function () {
  function initWizard(root) {
    var buttons = root.querySelectorAll('[data-helmet-button]');
    var panels = root.querySelectorAll('[data-helmet-panel]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-helmet-button');

        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-helmet-panel') !== id;
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-oblivion-helmet-wizard]').forEach(initWizard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
